<template>
    <div 
        v-if="isPageShow" 
        id="link-vip-multiple" 
        key="show-page">
        <div 
            v-if="!isActivityEnd" 
            key="activity">
            <header class="header">
                <img 
                    v-show="isHeaderShow" 
                    :src="headerImage" 
                    alt="picture" 
                >
                <div
                    v-if="ua.kkmh"
                    class="go-back" 
                    @click="closeWebview">
                    <img 
                        :src="goBack" 
                        alt="picture" 
                    >
                </div>
                
                <template v-else-if="!ua.miniprogram">
                    <div
                        v-if="isLogin"
                        class="user-info-box"
                        @click="loginOut">
                        <div
                            class="avatar-box">
                            <img
                                :src="userInfo.avatar_url"
                                alt="png">
                        </div>
                        <div class="user-name">{{ userInfo.nickname.length && userInfo.nickname.length > 8 ? userInfo.nickname.substring(0, 8) + '...' : userInfo.nickname }}</div>
                    </div>
                    <div
                        v-else
                        class="login-button"
                        @click="toLogin">
                        登录</div>
                </template>
                <section
                    v-verify:[canIPayOutOfKuaikan].stop="{
                        link: shareInfo.link,
                        callback: showDialog
                    }"
                    :class="{'fix-right': computedShowShare}"
                    class="rules-btn"
                >
                    <img
                        v-if="computedShowShare"
                        src="./img/rules.png" 
                        alt="picture">
                    <span v-else>规则说明</span>
                </section>
                <section
                    v-if="computedShowShare"
                    class="share-btn" 
                    @click="share()">
                    <img 
                        alt="picture" 
                        src="./img/share.png" 
                    >
                </section>
                <section 
                    :class="{black: !kkBackground}" 
                    class="kk-vip-info">
                    <img 
                        v-if="kkBackground" 
                        key="kk-bg" 
                        :src="kkBackground" 
                        alt="picture" 
                        class="kk-bg" 
                    >
                    <div class="kk-icon">
                        <img 
                            :src="kkIcon" 
                            alt="picture" 
                        >
                        <span 
                            v-if="kkVipCombo" 
                            :class="[comboClassMap[kkVipCombo]]" 
                            class="vip-type flex_layout flex_xy_center">{{ comboTagMap[kkVipCombo] }}</span>
                    </div>
                    <div class="kk-info">
                        <p class="info-title">{{ kkInfoTitle }}</p>
                        <p class="info-desc">{{ kkInfoDesc }}</p>
                    </div>
                </section>
            </header>
            <main 
                :class="{'no-trans': isIconFixed}" 
                class="container">
                <section class="vip-wrap">
                    <p 
                        v-if="selectLabel" 
                        key="selectLabel" 
                        class="select-label flex_layout flex_xy_center">{{ selectLabel }}</p>
                    <div 
                        :class="returnVipListClass" 
                        class="vip-list flex_layout">
                        <div 
                            v-for="item in vipList" 
                            :key="item.award_title" 
                            :class="returnVipItemClass" 
                            class="vip-item">
                            <div class="vip-icon-wrap">
                                <img 
                                    :src="item.award_icon" 
                                    alt="picture" 
                                >
                            </div>
                            <div 
                                :class="returnVipInfoClass" 
                                class="vip-info-wrap">
                                <p class="app-name">{{ item.award_title }}</p>
                                <p class="desc">{{ item.award_desc }}</p>
                            </div>
                        </div>
                    </div>
                    <div 
                        key="btn-group" 
                        :class="openBtnStatus == 'double' ? 'flex_layout flex_y_center flex_x_spacebetween' : ''" 
                        class="btn-group flex_layout flex_y_center">
                        <div 
                            v-if="openBtnStatus && openBtnStatus == 'disabled'" 
                            key="disabled" 
                            class="btn-item flex_layout flex_xy_center disabled">售卖期已结束</div>
                        <div 
                            v-if="openBtnStatus && openBtnStatus == 'cannot'"
                            key="cannot" 
                            class="btn-item flex_layout flex_xy_center disabled"
                            @click="cannotHandler">你已参与过活动</div>
                        <div
                            v-verify:[canIPayOutOfKuaikan].stop="{
                                link: shareInfo.link,
                                callback: toAssignPage
                            }"
                            v-if="openBtnStatus && (openBtnStatus == 'assign' || openBtnStatus == 'double')" 
                            key="assign-btn" 
                            :class="{'small' : openBtnStatus == 'double'}" 
                            class="btn-item flex_layout flex_xy_center assign"
                        >
                            领取{{ openBtnStatus == 'double' ? '' : '会员' }}权益
                        </div>
                        <div
                            v-verify:[canIPayOutOfKuaikan].stop="{
                                link: shareInfo.link,
                                callback: openVipHandler
                            }"
                            v-if="openBtnStatus && (openBtnStatus == 'buy' || openBtnStatus == 'double')" 
                            key="buy-btn"
                            :class="{'small' : openBtnStatus == 'double'}" 
                            class="btn-item flex_layout flex_xy_center buy"
                        >
                            <p>{{ btnText }}</p>
                            <p class="price"><span class="sell-price"><span class="small-rmb">¥</span><span class="num">{{ sellPrice }}</span></span><span 
                                v-if="openBtnStatus == 'buy'" 
                                key="origin-price" 
                                class="origin-price">¥{{ originPrice }}</span></p>
                            <p class="label flex_layout flex_xy_center">{{ sellType == 1 ? '' : (sellType == 2 ? '最高' : '') }}立省<span class="save-price">¥{{ originPrice - sellPrice }}</span></p>
                        </div>
                    </div>
                    <div class="assign-tips flex_layout flex_y_center flex_x_spacebetween">
                        <p 
                            v-show="buyTips" 
                            class="times">*{{ buyTips }}</p>
                        <p 
                            v-show="countdown" 
                            class="countdown">{{ countdown }}</p>
                    </div>
                </section>
               
                <!-- 抽奖模块 -->
                <!-- <section class="award-wrap">
                    <Award 
                        :award_lists="award_lists"
                        :lottery_balance="lottery_balance"
                        :user_record_list="user_record_list"
                        :is_login="isLogin"
                        :activity_name="LOTTER_NAME"
                        @toLogin="toLogin"
                        @showToast="showToast"
                        @openAwardDialog="openAwardDialog"
                        @openVipHandler="openVipHandler"
                        @doTrack="doTrack"
                    />
                </section> -->

                <!-- 抽奖模块 -->
                <section
                    v-if="LOTTER_NAME"
                    class="award-wrap">
                    <AwardCommon 
                        ref="AwardCommon"
                        :award_lists="award_lists"
                        :lottery_balance="lottery_balance"
                        :user_record_list="user_record_list"
                        :is_login="isLogin"
                        :activity_name="LOTTER_NAME"
                        @toLogin="toLogin"
                        @showToast="showToast"
                        @openAwardDialog="openAwardDialog"
                        @openVipHandler="openVipHandler"
                        @doTrack="doTrack"
                        @showAwardRule="showAwardRule"
                        @getUserRecordList="getMyRecordList"
                    />
                </section>

                <section class="rights-list">
                    <img 
                        alt="picture" 
                        src="./img/vip-title.png" 
                        class="rights-title">
                    <div 
                        :class="{fixed: isIconFixed}"
                        class="vip-icon-outter flex_layout flex_xy_center">
                        <div class="vip-icon-list flex_layout">
                            <div 
                                ref="refIconList" 
                                class="vip-list-wrap flex_layout flex_y_center flex_x_start">
                                <div
                                    v-verify:[canIPayOutOfKuaikan].stop="{
                                        link: shareInfo.link,
                                        callback: () => {
                                            iconClickHandler(index)
                                        }
                                    }"
                                    v-for="(item, index) in iconVipList" 
                                    ref="refIcon" 
                                    :key="item.award_title" 
                                    :class="{active: !index}" 
                                    class="vip-icon-item"
                                >
                                    <div 
                                        :class="index == 0 ? 'kk' : ''" 
                                        class="vip-icon">
                                        <img 
                                            :src="item.award_icon" 
                                            alt="picture" 
                                        >
                                    </div>
                                    <div class="vip-name">{{ item.award_title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vip-content-list">
                        <div 
                            v-for="item in iconVipList" 
                            ref="refContent" 
                            :key="item.award_title" 
                            class="vip-content-item">
                            <div class="top">
                                <img 
                                    alt="picture" 
                                    src="./img/icon-base.png" 
                                    class="icon-base">
                                <div class="vip-icon">
                                    <img 
                                        :src="item.award_icon" 
                                        alt="picture" 
                                    >
                                </div>
                                <div class="vip-info-box">
                                    <p class="vip-app-name flex_layout flex_x_spacestart flex_y_start">{{ item.words_info.link_vip_app }}&nbsp;<span 
                                        v-if="comboTagMap[item.words_info.link_vip_combo]" 
                                        :class="[comboClassMap[item.words_info.link_vip_combo]]" 
                                        class="vip-type flex_layout flex_xy_center">{{ comboTagMap[item.words_info.link_vip_combo] }}</span></p>
                                    <div class="vip-desc flex_layout flex_x_spacebetween flex_y_center"><p 
                                        v-for="desc in item.words_info.link_vip_desc" 
                                        :key="desc" 
                                        class="vip-desc-item flex_layout flex_xy_center"><em class="desc-icon"/>&nbsp;{{ desc }}</p></div>
                                </div>
                            </div>
                            <div class="bottom flex_layout flex_y_center">
                                <div 
                                    v-verify:[canIPayOutOfKuaikan].stop="{
                                        link: shareInfo.link,
                                        callback: () => {
                                            openContent(content)
                                        }
                                    }"
                                    v-for="content in item.contentList" 
                                    :key="content.title" 
                                    class="link-item"
                                >
                                    <div class="link-img">
                                        <img 
                                            :src="content.image" 
                                            alt="picture" 
                                        >
                                    </div>
                                    <div class="link-name">{{ content.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <div 
                v-if="isBtnFixed" 
                key="btn-wrap" 
                class="btn-wrap">
                <div 
                    :class="[openBtnStatus == 'double' ? 'flex_layout flex_y_center flex_x_spacebetween' : '', {fixed: isBtnFixed}]" 
                    class="btn-group flex_layout flex_y_center">
                    <div 
                        v-if="openBtnStatus && openBtnStatus == 'disabled'" 
                        key="disabled" 
                        class="btn-item flex_layout flex_xy_center disabled">售卖期已结束</div>
                    <div 
                        v-if="openBtnStatus && openBtnStatus == 'cannot'" 
                        key="cannot" 
                        class="btn-item flex_layout flex_xy_center disabled"
                        @click="cannotHandler">你已参与过活动</div>
                    <div
                        v-verify:[canIPayOutOfKuaikan].stop="{
                            link: shareInfo.link,
                            callback: toAssignPage
                        }"
                        v-if="openBtnStatus && (openBtnStatus == 'assign' || openBtnStatus == 'double')" 
                        key="assign-btn" 
                        :class="{'small' : openBtnStatus == 'double'}" 
                        class="btn-item flex_layout flex_xy_center assign"
                    >
                        领取{{ openBtnStatus == 'double' ? '' : '会员' }}权益
                    </div>
                    <div
                        v-verify:[canIPayOutOfKuaikan].stop="{
                            link: shareInfo.link,
                            callback: openVipHandler
                        }"
                        v-if="openBtnStatus && (openBtnStatus == 'buy' || openBtnStatus == 'double')" 
                        key="buy-btn" 
                        :class="{'small' : openBtnStatus == 'double'}" 
                        class="btn-item flex_layout flex_xy_center buy" 
                    >
                        <p>{{ btnText }}</p>
                        <p class="price"><span class="sell-price"><span class="small-rmb">¥</span><span class="num">{{ sellPrice }}</span></span><span 
                            v-if="openBtnStatus == 'buy'" 
                            key="origin-price" 
                            class="origin-price">¥{{ originPrice }}</span></p>
                        <p class="label flex_layout flex_xy_center">{{ sellType == 1 ? '' : (sellType == 2 ? '最高' : '') }}立省<span class="save-price">¥{{ originPrice - sellPrice }}</span></p>
                    </div>
                </div>
                <div class="btn-base"/>
            </div>
        </div>
        <div 
            v-else 
            key="is-end" 
            @click="closeWebview">
            <img 
                v-if="ua.kkmh" 
                :src="goBack" 
                alt="picture" 
                class="error-go-back">
            <img 
                alt="picture" 
                src="./img/error.png" 
                class="error">
            <p class="error-text">活动已结束<br>下次再来吧</p>
        </div>
        <dialog-comp 
            ref="refDialog" 
            :rules="rule_text" 
            title="活动规则" />

        
        <!-- <confirm-comp 
            ref="refConfirm" 
            @open_callback="showCashdesk"
            @bind_native_phone_callback="bindNativePhone" />  -->
       

        <!-- 收银台组件 -->
        <Cashdesk
            ref="cashdesk"
            :visible.sync="visible_cashdesk"
            :param="param_cashdesk"
            @dialogOpen="receiveCashdeskDialogOpen"
            @dialogClose="receiveCashdeskDialogClose"
            @payMessage="receiveCashdeskPayMessage"
            @errorMessage="receiveCashdeskErrorMessage"
            @goodData="receiveCashdeskGoodData"
        />

        <!-- 绑定账号(变更账号) & 确认账号弹窗 --->
        <bind-account-popup
            v-if="showBindAccountPopup"
            :user-data="userBindAccount"
            :tisp-text="confirmAccountPopupTips"
            @opencallback="showCashdesk"
            @closeBindAccountPopup="(res) => {
                showBindAccountPopup = false;
                userBindAccount = res;
            }"
        />

        <!-- 抽奖信息弹窗 -->
        <AwardDialog
            :visible="show_award_mask"
            :is_record="is_record"
            :is_unassigned_award="is_unassigned_award"
            :record_list="record_list"
            :stop_award="stop_award"
            :unassigned_text="unassigned_text"
            @showToast="showToast"
            @closeDialog="closeAwardDialog"
        />

        <!-- 退出登陆弹窗 -->
        <LoginOutDialog
            ref="LoginOutDialog"
            @initPage="loginOutCallback"/>
    </div>
</template>

<script>
import verify from "./js/v-verify";
import doTrack from "./js/track";
import jointImageSuffix from "@kkmh/image-format";
import { tools } from "@/assets/js/SDK_copy/libs/sdk.tools";
import DialogComp from "./comp/dialog";
// import ConfirmComp from "./comp/confirm";
import BindAccountPopup from "./comp/BindAccountPopup"; // 活动首页绑定账号
import {Cashdesk} from "@kkmh/pays";
import { 
    forward, 
    // show_tips, 
    close_page, 
    share, 
    switch_page, 
    /* receive_page_status 2021-11-10废弃 使用新弹窗解决 */
} from "@kk/h5-sdk";
import { toast } from "@/assets/fe_js/common/base/fn/message.js";
import { kkmh } from "@/assets/js/common/kkmh_wk.js";
import { miniInit, miniNav} from "@kkmh/utils";
import { getMembership } from "@/api/pay/free_vip.api.js";
import { getUserLogin } from "@/api/common/user.js";
import { 
    getHomepageInfo, 
    getKuaikanGood,
    /* getUserBaseInfo 2021-11-10废弃 使用新弹窗解决 */
    getUnassignedAward
} from "@/api/pay/link_vip_multiple.api.js";
import { getQueryOpenAuth } from "@/api/pay/link_vip_double.api.js";

// 抽奖模块
// comp
import Award from "./comp/Award.vue";
import AwardCommon from "./comp/AwardCommon.vue";
import AwardDialog from "./comp/AwardDialog";
// 退出登陆弹窗
import LoginOutDialog from "./comp/LoginOutDialog.vue";
// api 
import { getSummary, getMyRecordList } from "./api/lottery.api.js";


export default {
    components: {
        Cashdesk,
        DialogComp,
        // ConfirmComp,
        BindAccountPopup,
        Award,
        AwardCommon,
        AwardDialog,
        LoginOutDialog
    },
    directives: {
        verify
    },
    data () {
        return {
            canIPayOutOfKuaikan: false, // 在端外是否能支付
            visible_cashdesk: false,
            param_cashdesk: {},
            showShare: false,
            shareInfo: {},
            ua: window.__gvalkkmh ? window.__gvalkkmh.ua : {},
            // eslint-disable-next-line no-undef
            kkIcon: require("./img/kk-icon.png"),
            // eslint-disable-next-line no-undef
            goBack: require("@/assets/fe_img/direction/arrow_left_gray@2x.png"),
            isPageShow: false,
            isActivityEnd: false,
            isLoading: false,
            isLogin: false,
            VIP_TYPE: "",
            TRIGGER_PAGE: "",
            ACTIVITY_STATUS: "",
            PAY_ACTIVITY_NAME: "",
            ACTIVITY_NAME: "",
            AWARD_NAME: "",

            LOTTER_NAME: "", // 奖池名称

            sellType: 0,
            vipList: [],
            iconVipList: [],
            comboTagMap: {
                1: "连续包月",
                2: "月卡",
                3: "季卡",
                4: "年卡"
            },
            comboClassMap: {
                1: "auto-renew",
                2: "month",
                3: "season",
                4: "year"
            },
            timer: "",
            countdown: "",
            totalChargeTimes: "",
            openBtnStatus: "",
            selectLabel: "",
            isSupportIAP: 0, // 运营位是否支持越狱
            isJailbreakPhone: window.__gvalkkmh ? (window.__gvalkkmh.sys ? window.__gvalkkmh.sys.is_jailbroken_phone : false) : false,
            deviceId: window.__gvalkkmh ? (window.__gvalkkmh.sys ? window.__gvalkkmh.sys.device_id : "") : "",
            kkVipCombo: 0,
            kkInfoTitle: "",
            kkInfoDesc: "",
            kuaikanGood: {},
            originPrice: 0,
            sellPrice: 0,
            isBtnFixed: false,
            isIconFixed: false,
            activityRules: "",
            iconListHeight: 0,
            iPhonex: false,
            headerImage: "",
            isHeaderShow: true,
            kkBackground: "",
            buyTips: "",
            btnText: "",
            // userBasePhone: "", // 用户平台手机号 2021-11-10废弃 使用新弹窗解决
            showBindAccountPopup: false, // 是否显示绑定账号(变更账号) & 确认账号弹窗
            userBindAccount: {}, // 用户绑定的领取奖励号码信息
            confirmAccountPopupTips: "", // 绑定账号&确认账号弹窗提示文案

            rule_text: "", // 规则文案

            award_lists: [], // 奖品列表
            lottery_balance: 0, // 抽奖次数
            user_record_list: [], // 用户获奖记录
            show_award_mask: false, // 是否展示抽奖弹窗
            is_record: true, // 弹窗类型是否是记录
            record_list: [], // 记录列表
            stop_award: {}, // 抽中的奖品
            award_rule_text: "", // 抽奖活动规则

            userInfo: {}, // 用户信息

            receive_right_target: {}, // 活动主页-领取权益按钮跳转链接
            charge_type: 0, // 充值类型
            unassigned_award: [], // 未领取奖励列表
            is_unassigned_award: false, // 是否是未领取奖励弹窗
            unassigned_text: "以下奖品请在1天内手动领取", // 未领取奖励弹窗文案
        };
    },
    computed: {
        computedShowShare() {
            return this.ua.kkmh && this.showShare;
        },
        returnVipListClass() {
            const doubleCSSStr = "double flex_y_center flex_x_spacebetween";
            const tripleCSSStr = "triple flex_wrap flex_xy_center";
            const quadrupleCSSStr = "four flex_wrap flex_xy_center";
            let length = this.vipList.length;
            // 有且仅有两个 单独使用
            if (length == 2) return doubleCSSStr;
            // 先判断数组长度能不能被整除(4比3优先)
            if (length % 4 == 0) return quadrupleCSSStr;
            if (length % 3 == 0) return tripleCSSStr;
            // 不能整除的取余数大的情况
            return (length % 4 > length % 3) ? quadrupleCSSStr : tripleCSSStr;
        },
        returnVipItemClass() {
            return this.vipList.length == 2 ? "flex_layout flex_x_start flex_y_center" : "";
        },
        returnVipInfoClass() {
            return this.vipList.length == 2 ? "flex_layout flex_x_center flex_y_start flex_flexDirection_column" : "";
        },
        returnWebHost() {
            return "https://"+ (/kuaikanmanhua/.test(location.host) ? "m.kuaikanmanhua.com" : "m.quickcan.cn");
        },
    },
    watch: {
        isIconFixed: {
            // 取消吸顶后 滚动到初始位置
            handler: function(val) {
                this.$refs.refIconList.scrollTop = 0;
                this.$refs.refIconList.scrollLeft = 0;
                !val && this.$nextTick(() => {
                    let list = this.$refs.refIcon;
                    list.map((item, index) => {
                        item.classList.remove("active");
                        if (index == 0) item.classList.add("active");
                    });
                });
            }
        }
    },
    created () {
        // 加载小程序sdk
        if (window.__gvalkkmh.ua.miniprogram) {
            miniInit();
        }
        this.TRIGGER_PAGE = tools.urlValue().origin || "";
        this.ACTIVITY_NAME = tools.urlValue().activity_name || "link_vip_module_charge";
        this.AWARD_NAME = tools.urlValue().award_name || "send_5_assign";
        this.LOTTER_NAME = tools.urlValue().lot_name || "";
        
        this.CPS = tools.urlValue().cps || "";

        this.isSupportIAP = parseInt(tools.urlValue().non_iap_supported || 0);
        this.initPage();
    },
    // 2021-11-10废弃 使用新弹窗解决
    // beforeMount() {
    //     if (window.__gvalkkmh.ua.kkmh) {
    //         receive_page_status({callback: (res) => {
    //             if (res.code == 200 && !!res.data.curr_page_is_visible) this.getUserBaseInfo();
    //         }});
    //     }
    // },
    methods: {
        cannotHandler() {
            // this.showToast("同一用户限购1次。详情请查看活动规则");
            this.showToast("已超过购买上限，详见活动规则");
        },
        share() {
            if (!this.showShare) return;
            let {title, desc, image} = this.shareInfo;
            let link = location.href;
            share({
                title,
                desc,
                image,
                link,
                platform: [
                    {name : "Wechat", type: 1, link, image},
                    {name : "WechatMoments", type: 1, link, image, title, desc},
                    {name : "QQ", type: 1, link, image, title, desc},
                    {name : "QZone", type : 1, link, image},
                    {name : "SinaWeibo", type : 1, link, image, title, desc},
                ]
            });
        },
        wxShare() {
            let { title, desc, image } = this.shareInfo;
            kkmh.wxShare({
                title,
                desc,
                imgurl: image,
            });
        },
        initListener() {
            let transform = window.getComputedStyle(document.getElementsByClassName("container")[0]).transform;
            // matrix(scaleX, skewY, skewX, scaleY, translateX, translateY)
            let transformMatrix = Math.abs(transform.slice(7, transform.length - 1).split(",")[5]);
            let iconListOffsetTop = document.querySelector(".vip-icon-outter").getBoundingClientRect().top;
            let btnGroupOffsetTop = document.querySelector(".btn-group").offsetTop;
            let btnGroupHeight = document.querySelector(".btn-group").clientHeight;
            let containerOffsetTop = document.querySelector(".container").offsetTop;
            window.addEventListener("scroll", () => {
                let windowScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // icon图标吸顶
                if (windowScroll >= iconListOffsetTop ) {
                    this.isIconFixed = true;
                } else {
                    this.isIconFixed = false;
                }
                // 开通按钮吸底
                if (windowScroll >= btnGroupOffsetTop + containerOffsetTop + btnGroupHeight - transformMatrix) {
                    this.isBtnFixed = true;
                } else {
                    this.isBtnFixed = false;
                }
            });
        },
        async initPage() {
            this.isLogin = !!window.__gvalkkmh.user.id;
            if (!this.ua.kkmh) {
                !this.isLogin && this.getUserLogin();
            }
            // this.getUserBaseInfo(); // 2021-11-10废弃 使用新弹窗解决
            await this.getHomepageInfo();
            this.getMembership();
            if(this.LOTTER_NAME){
                this.getSummary();
                if(this.isLogin) {
                    this.getMyRecordList();
                }
            }
            this.getKuaikanGood().then(() => {
                this.sellPrice = this.returnSellPrice();
            });
        },
        // 2021-11-10废弃 使用新弹窗解决
        // getUserBaseInfo() {
        //     this.isLoading = true;
        //     return getUserBaseInfo().then(res => {
        //         this.isLoading = false;
        //         if (res.data.code === 200) {
        //             this.userBasePhone = res.data.data.phone;
        //         }
        //     }).catch(err => {
        //         this.isLoading = false;
        //         this.showToast(`[getUserBaseInfo-catch]: ${err.message || "网络错误"}`);
        //     });
        // },
        getMembership() {
            return getMembership({ type: 2 }).then(res => {
                if (res.data.code === 200) {
                    this.VIP_TYPE = res.data.data.vip_common.vip_classify;
                }
                this.doTrack("PayActivityPV");
            }).catch(err => {
                this.showToast(`[getMembership-catch]: ${err.message || "网络错误"}`);
            });
        },
        getUserLogin() {
            return getUserLogin().then(res => {
                let {code, data} = res.data;
                this.isLogin = code == 200;
                if (code == 200) {
                    const id = data.user.id;
                    this.userInfo = data.user;
                    window.__gvalkkmh.user.id = id;
                    this.isLogin = !!window.__gvalkkmh.user.id;
                    kksa.identify(id.toString());
                }
            }).catch(err => {
                this.showToast(`[getUserLogin-catch]: ${err.message || "网络错误"}`);
            });
        },
        getHomepageInfo() {
            this.isLoading = true;
            return getHomepageInfo({
                activity_name: this.ACTIVITY_NAME,
                award_name: this.AWARD_NAME
            }).then(res => {
                let {code, data, message} = res.data;
                this.isLoading = false;
                this.isPageShow = true;
                if (data.limit_code == 2) {
                    //1表示触发风控 2表示触发阈值
                    this.isActivityEnd = true;
                    return;
                }
                if (code == 401) return this.toLogin("must");
                if (code != 200) return this.showToast(message);
                // 活动结束
                if (data.server_time >= data.activity_end_time) {
                    this.isActivityEnd = true;
                    this.ACTIVITY_STATUS = "不可领取不可购买";
                    return;
                }
                // 领取期 如果有未领取的就展示领取 没有未领取的就展示售卖已结束
                if (data.charge_end_time <= data.server_time && data.server_time < data.activity_end_time) {
                    this.openBtnStatus = data.can_assign_count <= 0 ? "disabled" : "assign";
                    this.ACTIVITY_STATUS = data.can_assign_count > 0 ? "可领取不可购买" : "不可领取不可购买";
                    this.countdown = "请在个人有效期内速速领取";
                    window.clearInterval(this.timer);
                }
                // 售卖期
                if (data.charge_end_time > data.server_time) {
                    // charged_count 已开通的次数 
                    // can_assign_count 可领取奖励的次数
                    // total_charge_count 后台配置可以开通的次数
                    // risk_count 已达到风控 风控的次数
                    let cannotBuy = (data.risk_count >= data.total_charge_count); // 到达风控就不可以购买
                    let canAssign = data.can_assign_count > 0 || data.charged_count > 0; // 有剩余可领取次数 或者 曾经开通过
                    this.openBtnStatus = canAssign ? (cannotBuy ? "assign" : "double") : (cannotBuy ? "cannot" : "buy");
                    this.ACTIVITY_STATUS = canAssign ? (cannotBuy ? "可领取不可购买" : "可购买可领取") : (cannotBuy ? "不可领取不可购买" : "可购买不可领取");

                    this.setCountdown(data.server_time, data.charge_end_time);
                }
                const {image_info, words_info} = data; 
                this.canIPayOutOfKuaikan = !!+words_info.can_i_pay_out_of_kk;
                // 分享文案
                this.showShare = !!+words_info.is_show_share;
                this.shareInfo = {
                    title: words_info.share_title,
                    desc: words_info.share_desc,
                    image: image_info.share_icon,
                    link: words_info.share_link
                };
                if (this.showshare) this.wxShare();
                data.words_info = data.words_info || {};
                this.userBindAccount = data.account; // userBindAccount: {} 绑定的账号信息

                // 充值类型 0 非直充  1 直充
                this.charge_type = data.account ? (data.account.charge_type || 0) : 0;

                this.confirmAccountPopupTips = data.words_info.confirm_account_popup_tips || ""; // 弹窗提示文案数据
                // 活动头图
                this.headerImage = data.image_info.header;
                this.kkBackground = data.image_info.kk_info_bg;
                // 按钮文案
                this.btnText = data.words_info.btn_text;
                // 活动规则
                this.activityRules = data.words_info.activity_rules;
                // 抽奖模块规则
                this.award_rule_text = data.words_info.award_rule_text || "";
                // 活动类型 1-买一得n 2-买一选n
                this.sellType = data.words_info.sell_type;
                // 活动埋点
                this.PAY_ACTIVITY_NAME = data.words_info.pay_activity_name;
                // 开通提示
                this.buyTips = data.words_info.buy_tips;
                // 每人可以开通的总次数
                this.totalChargeTimes = data.total_charge_count;
                // 原价
                this.originPrice = data.words_info.origin_price;
                // 右上角角标
                this.selectLabel = data.words_info.right_top_label;
                // 快看商品类型
                this.kkVipCombo = +data.words_info.kk_vip_combo;
                this.kkInfoTitle = data.words_info.kk_info_title;
                this.kkInfoDesc = data.words_info.kk_info_desc;

                // 活动主页-领取权益按钮跳转链接
                this.receive_right_target = data.target_info.receive_right_target || {};
                // 未领取奖励弹窗文案
                this.unassigned_text = data.words_info.unassigned_text || "以下奖品请在1天内手动领取";

                // 参与活动的会员列表
                this.vipList = data.awards.map(item => {
                    item.words_info.link_vip_desc = item.words_info.link_vip_desc ? item.words_info.link_vip_desc.split(",") : [];
                    // 合作方内容图展示数量取决于 后台配的 link_vip_content_image 真正有值的有几个
                    let imageLength = Object.keys(item.image_info).filter(img => {
                        return img.includes("link_vip_content_image");
                    }).filter(img => {
                        return item.image_info[img];
                    }).length;
                    this.$set(item, "contentList", new Array(imageLength).fill().map((img, index) => {
                        let order = index + 1;
                        return {
                            title: item.words_info["link_vip_content_title_" + order],
                            image: jointImageSuffix({src: item.image_info["link_vip_content_image_" + order], width: 200}),
                            target: item.target_info["link_vip_content_target_" + order] ? item.target_info["link_vip_content_target_" + order].target_web_url : "",
                        };
                    }));
                    return item;
                });
                // 快看数据信息
                let kkImageLength = Object.keys(data.image_info).filter(img => {
                    return img.includes("kk_content_image");
                }).filter(img => {
                    return data.image_info[img];
                }).length;
                let kkInfo = {
                    award_icon: this.kkIcon,
                    award_title: "快看漫画",
                    words_info: {
                        link_vip_combo: this.kkVipCombo,
                        link_vip_app: "快看漫画",
                        link_vip_desc: ["KK币礼包","会员提前看","整本限免"],
                    },
                    contentList: new Array(kkImageLength).fill().map((img, index) => {
                        let order = index + 1;
                        return {
                            isKuaikan: true,
                            title: data.words_info["kk_content_title_" + order],
                            image: jointImageSuffix({src: data.image_info["kk_content_image_" + order], width: 200}),
                            target: data.words_info["kk_content_id_" + order]
                        };
                    })
                };
                this.iconVipList = this.vipList.concat();
                this.iconVipList.unshift(kkInfo);
                this.$nextTick(() => {
                    // 页面滚动监听
                    this.initListener();
                });
            }).catch(err => {
                this.isLoading = false;
                this.showToast(`[getHomepageInfo-catch]: ${err.message || "网络错误"}`);
            });
        },
        // 获取大转盘奖品列表
        getSummary() {
            getSummary({ activity_name: this.LOTTER_NAME }).then(res => {
                let {code, data, message} = res.data;
                if (code != 200) return this.showToast(message);
                this.award_lists = this.handleSummary(data.awards||[]);
                this.lottery_balance = data.lottery_balance || 0;
            }).catch(err => {
                this.showToast(`[getSummary-catch]: ${err.message || "网络错误"}`);
            });
        },
        // 处理抽奖信息
        handleSummary(arr){
            let newArr = [];
            let data = this.deepClone(arr);
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                item.award_icon = jointImageSuffix({
                    src: item.award_icon,
                    width: 188,
                    quality: "h"
                });
                newArr.push(item);
            }
            return newArr;
        },
        // 获取用户中奖记录
        getMyRecordList(){
            getMyRecordList({ activity_name: this.LOTTER_NAME }).then(res => {
                let {code, data, message} = res.data;
                if (code != 200) return this.showToast(message);
                this.user_record_list = data.list || [];
            }).catch(err => {
                this.showToast(`[getMyRecordList-catch]: ${err.message || "网络错误"}`);
            });
        },
        // 打开奖励弹窗
        openAwardDialog(is_record=true, record_list=[], stop_award={}){
            this.is_record = is_record;
            this.record_list = record_list;
            this.stop_award = stop_award;
            this.show_award_mask = true;
        },
        // 关闭奖励弹窗
        closeAwardDialog() {
            this.show_award_mask = false;
            this.is_unassigned_award = false;
            // this.$refs.AwardCommon.startSwiper();
        },
        // 展示抽奖规则
        showAwardRule() {
            this.rule_text = this.award_rule_text;
            this.$refs.refDialog.show("rules");
        },
        // 使用递归的方式实现数组、对象的深拷贝
        deepClone(obj) {
            // 判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
            var objClone = Array.isArray(obj) ? [] : {};
            // 进行深拷贝的不能为空，并且是对象或者是
            if (obj && typeof obj === "object") {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (obj[key] && typeof obj[key] === "object") {
                            objClone[key] = this.deepClone(obj[key]);
                        } else {
                            objClone[key] = obj[key];
                        }
                    }
                }
            }
            return objClone;
        },
        setCountdown(now, end) {
            let addZero = (i) => {
                return i < 10 ? "0" + i : i + "";
            };
            let countdown = () => {
                if (cd <= 0) {
                    this.countdown = "活动已结束";
                    this.timer && window.clearInterval(this.timer);
                    return;
                }
                var d = parseInt(cd / (24*60*60));
                var h = parseInt(cd / (60 * 60) % 24);
                var m = parseInt(cd / 60 % 60);
                d = addZero(d);
                h = addZero(h);
                m = addZero(m);

                this.countdown = `活动结束倒计时: ${d}天${h}时${m}分`;
                cd--;
            };
            var cd = parseInt((end - now) / 1000);
            countdown();
            this.timer && window.clearInterval(this.timer);
            this.timer = setInterval(countdown, 1000);
        },
        getKuaikanGood(compel_iap = false) {
            this.isLoading = true;
            let data = {
                pay_info: {
                    comic_id: 0, //0, //int 漫画id
                    topic_id: 0, //0, //int 专题id
                    source_type: 0, //0,//int 1：签到，2：皇冠，3：作品，4：礼包
                    invite_code: "", //'',//string 邀请码
                    coupon_id: "", //'', //string 优惠券id
                    third_activity: this.ACTIVITY_NAME, //'2019act', //添加订单接口，所要传入的活动名称参数
                },
                third_activity: this.ACTIVITY_NAME,
                non_iap_supported: this.isSupportIAP, //运营位是否支持越狱，1表示支持
                compel_iap, // 是否强制iap
                non_iap_supported_device: this.isJailbreakPhone,
                platform: this.ua.kkmh ? (this.ua.iphone ? 2 : 1) : "", // 1-安卓，2-ios，3-h5，
            };
            let headers = {
                "X-Device": this.deviceId,
            };
            return getKuaikanGood({ data, headers }).then(res => {
                this.isLoading = false;
                let {code, data:data1, message} = res.data;
                if (code == 401) return this.toLogin("must");
                if (code != 200) return this.showToast(message);
                let goodList = data1.members ? data1.members[0] : [];
                let kkGoodList = goodList.member_goods ? goodList.member_goods.filter(item => item.combo == this.kkVipCombo) : [];
                this.kuaikanGood = kkGoodList.length ? kkGoodList[0] : {};
            }).catch(err => {
                this.isLoading = false;
                this.showToast(`[getKuaikanGood-catch]: ${err.message || "网络错误"}`);
            });
        },
        returnSellPrice() {
            if (!this.kuaikanGood.id) return 0;
            let good = this.kuaikanGood;
            let coupon = good ? (good.coupon ? (good.coupon.usable_list[0] || {}) : {}) : {};
            return good.price.real_price / 100 - (coupon.id ? coupon.amount / 100 : 0);
        },
        // 开通会员
        openVipHandler() {
            this.judgeLoginStatus().then(res => {
                let loginStatus = res;
                if (!loginStatus) return this.toLogin();
                if (!this.kuaikanGood.id) return;
                getQueryOpenAuth({
                    activity_name: this.ACTIVITY_NAME,
                    award_name: this.AWARD_NAME
                }).then(res => {
                    let {code, data, message} = res.data;
                    if (code != 200) return this.showToast(message);
                    // 这里code = 200 进行确认账号 / 变更账号信息 
                    if (data.code == 200) {
                        this.showBindAccountPopup = true;
                        // 2021-11-10废弃 使用新弹窗解决
                        // this.$refs.refConfirm.show({
                        //     phone: this.userBasePhone
                        // });
                    } else {
                        this.showToast(data.message);
                    }
                });
                // this.showCashdesk();
            });
        },
        // h5 掉起收银台支付
        showCashdesk() {
            let callback = () => {
                let good = this.kuaikanGood;
                let coupon = good ? (good.coupon ? (good.coupon.usable_list[0] || {}) : {}) : {};
                let params = {
                    ButtonName: this.btnText,
                    CurrentPrice: good.price.real_price,
                    MembershipPrdName: good.title
                };
                this.doTrack("PayActivityBtnClk", {
                    ...params
                });
                this.clickOpenDialog({
                    good_type: 2,
                    good_id: good.id,
                    third_activity: this.ACTIVITY_NAME, //添加订单接口，所要传入的活动名称参数
                    comic_id: 0, //int 漫画id
                    topic_id: 0, //int 专题id
                    source_type: 0, //int 1：签到，2：皇冠，3：作品，4：礼包
                    invite_code: "",//string 邀请码
                    coupon_id: coupon.id,
                    trigger_page: this.PAY_ACTIVITY_NAME, //埋点时的来源英文名称，MemberFeature（会员权益页面）
                    origin: this.TRIGGER_PAGE,
                    cps: this.CPS, // cps
                });
            };
            getQueryOpenAuth({
                activity_name: this.ACTIVITY_NAME,
                award_name: this.AWARD_NAME
            }).then(res => {
                res = res || {};
                res.data = res.data ||{};
                let {code, data, message} = res.data;
                if (code != 200) return this.showToast(message);
                if (data.code == 200) {
                    callback(); // 拉起收银台
                } else {
                    this.showToast(data.message);
                }
            }).catch(err => {
                let Console = console;
                Console.warn(err);
            });
            
        },
        setCompParam(opt={}){
            //不必须字段-key可以省略。
            this.param_cashdesk = {
                //接口所需字段
                good_type           : opt.good_type || 0,               //必须-int 1.kkb 2.vip
                good_id             : opt.good_id || 0,                 //必须-int 76
                third_activity      : opt.third_activity || "",         //不必须-string （pay_info字段） 活动ID
                comic_id            : opt.comic_id || 0,                //不必须-int （pay_info字段） 漫画id
                topic_id            : opt.topic_id || 0,                //不必须-int （pay_info字段） 专题id
                source_type         : opt.source_type || 0,             //不必须-int （pay_info字段） 1：签到，2：皇冠，3：作品，4：礼包
                invite_code         : opt.invite_code || "",            //不必须-string （pay_info字段） 邀请码
                coupon_id           : opt.coupon_id || "",              //不必须-string （pay_info字段）【vip相关】输入优惠券id
                vip_source          : opt.vip_source || "",             //不必须-string （pay_info字段）【vip相关】get_entrance_param协议里获取的vip_source字段
                non_iap_supported   : opt.non_iap_supported || 0,       //不必须-int 运营位是否支持越狱，1表示支持
                //埋点所需字段
                cps                 : opt.cps || "",                    //不必须-string 下单接口时要传递的字段，也用作埋点上报
                trigger_page        : opt.trigger_page || "",           //不必须-string （track_info字段）埋点属性TriggerPage
                origin              : opt.origin || "",                 //不必须-string （track_info字段）埋点属性EntranceName
                notice_type         : opt.notice_type || "",            //不必须-string （track_info字段）【vip相关】get_entrance_param协议里获取的notice_type字段
                send_comic          : opt.send_comic || "",             //不必须-string （track_info字段）【vip相关】定向限免埋点-assign接口中send_comic字段
                free_pay_rate       : opt.free_pay_rate || "",          //不必须-string （track_info字段）【vip相关】定向限免埋点-assign接口中free_pay_rate字段
                //回掉地址
                redirect_url        : opt.redirect_url || location.href,//不必须-string 支付成功之后想跳回的h5地址
                //小程序
                bind_phone          : opt.bind_phone || 1,              //不必须-int 百度小程序支付前验证是否需要绑定手机号，默认：0 不绑定
                activity_name       : this.PAY_ACTIVITY_NAME || "联合会员买1赠N活动", //不必须-string （track_info字段） 用作埋点上报
                popup_name           : this.PAY_ACTIVITY_NAME || "联合会员买1赠N活动", //不必须-string （track_info字段） 用作埋点上报
                activity_mark        : this.PAY_ACTIVITY_NAME || "联合会员买1赠N活动", //不必须-string （track_info字段） 用作埋点上报
                pay_activity_name     : this.PAY_ACTIVITY_NAME || "联合会员买1赠N活动", //不必须-string （track_info字段） 用作埋点上报
            };
        },
        // 设置组件数据
        clickOpenDialog(opt){
            this.setCompParam(opt);
            this.visible_cashdesk = true;
        },
        // 收银台组件-接收 : 打开
        receiveCashdeskDialogOpen(){
        },
        // 收银台组件-接收 : 关闭
        receiveCashdeskDialogClose(){
        },
        // 收银台组件-接收 : 支付信息
        receiveCashdeskPayMessage(res){
            let {code, data={}, message=""} = res;
            if (code !== 200) {
                if (message && typeof message === "string") {
                    this.showToast(message);
                } else {
                    this.showToast("返回数据异常, 请稍候再试!");
                }
                return;
            }
            let params = {
                ButtonName: this.btnText,
                CurrentPrice: this.kuaikanGood.price.real_price,
                MembershipPrdName: this.kuaikanGood.title
            };
            if (data.pay_status === 1) {
                // 支付成功, 状态修改
                this.doTrack("PayActivityBtnClk", {
                    ...params,
                    IsOpenSuccess: 1,
                });
                if(this.charge_type) {
                    this.getUnassignedAward();   
                } else {
                    this.showToast("开通成功，请至页面内领取");
                }
                this.initPage();
                return;
            }
            if (data.pay_status === 2) {
                // 支付失败
                this.doTrack("PayActivityBtnClk", {
                    ...params,
                    IsOpenSuccess: 0,
                });
                return;
            }
            if (data.pay_status === 3) {
                // 用户主动取消
                return;
            }
            if (data.pay_status === 4) {
                // 好友代付
                return;
            }
            if (data.pay_status === 5) {
                // 没有找到对应商品
                this.showToast("没有找到对应商品!");
                return;
            }
            if (data.pay_status === 6) {
                // 好友支付回退
                return;
            }
            // 苹果越狱支付
            if (data.pay_status === 7 && data.pay_payment.type === 4) {
                this.showToast("支付环境已刷新, 请重新尝试购买");
                this.getKuaikanGood(true);
            }
        },
        // 收银台组件-接收 : 出错
        receiveCashdeskErrorMessage(){
        },
        // 收银台组件-接收 : vip/kkb 商品信息
        receiveCashdeskGoodData(){
        },
        async toLogin(mode = "need") {
            if (this.isLogin) return;
            // 端内
            if (this.ua.kkmh) {
                await window.h5init({login_mode: mode});
                window.__gvalkkmh.user.id && this.initPage();
                return;
            }
            // 小程序
            if (this.ua.miniprogram) return miniNav("/pages/login/login");
            // 端外
            let webHost = "https://"+ (/kuaikanmanhua/.test(location.host) ? "m.kuaikanmanhua.com" : "m.quickcan.cn");
            location.href = webHost + "/mob/login?redirect=" + encodeURIComponent(location.href);
        },
        // 突出登陆
        loginOut() {
            this.$refs.LoginOutDialog.openDialog();
        },
        // 获取未领取成功的奖品
        getUnassignedAward() {
            this.isLoading = true;
            getUnassignedAward({ 
                activity_name: this.ACTIVITY_NAME,
                award_names: this.AWARD_NAME
            }).then(res => {
                let {code, data} = res.data;
                this.isLoading = false;
                if (code != 200) return ;
                this.unassigned_award = data.direct_award_view || [];
                if(this.unassigned_award.length) {
                    this.is_record = true;
                    this.is_unassigned_award = true;
                    this.record_list = [];
                    for (let i=0; i<this.unassigned_award.length; i++) {
                        if(this.unassigned_award[i].award_title) {
                            this.record_list.push(this.unassigned_award[i]);
                        }
                    }   
                    this.show_award_mask = true;
                } else {
                    this.showToast("开通成功，请至页面内领取");
                }
            }).catch(() => {
                this.isLoading = false;
                this.showToast("开通成功，请至页面内领取");
            });
        },
        // 判断是否登录
        // 该方法主要是为了处理 浏览器环境 登录后连续返回导致状态不一致的问题(因为location.href导致打开了两个页面 两个页面状态不一致)
        async judgeLoginStatus() {
            if (!this.ua.kkmh) {
                if (this.isLogin) return true;
                // 如果没登录 尝试获取一次最新的登录状态 如果最新的登录态登录了更新一次页面
                await this.getUserLogin();
                this.isLogin && this.initPage();
                return this.isLogin;
            } else {
                return this.isLogin;
            }
        },
        showToast(text) {
            toast(text);
            // if (!this.ua.kkmh) return toast(text);
            // return show_tips({text, time: 0, style: 1, type: 2});
        },
        doTrack(eventName, params) {
            let prototype = {
                PayActivityName: this.PAY_ACTIVITY_NAME,
                ActivityStatus: this.ACTIVITY_STATUS,
                MembershipClassify: this.VIP_TYPE,
            };
            if (params) {
                prototype = Object.assign(prototype, params);
            }
            doTrack(eventName, prototype);
        },
        closeWebview() {
            close_page({animation: 1});
        },
        openContent(item) {
            this.doTrack("PayActivityBtnClk", {
                TopicName: item.title
            });
            if (!item.target) return;
            if (item.isKuaikan) {
                if (this.ua.kkmh) return forward({
                    totype: "native",
                    topage: "loadtopic/0",
                    todata: {id: item.target},
                });
                location.href = `${this.returnWebHost}/mobile/${item.target}/list`;
            } else {
                if (this.ua.kkmh) return forward({
                    totype: "h5",
                    topage: item.target,
                    todata: {},
                });
                location.href = item.target;
            }
        },
        showDialog() {
            this.rule_text = this.activityRules;
            this.$refs.refDialog.show("rules");
        },
        toAssignPage() {
            this.doTrack("PayActivityBtnClk", {
                ButtonName: `领取${this.openBtnStatus == "double" ? "" : "会员"}权益`
            });
            let url = `${location.origin}/native_pay_vip_link_vip_multiple_list.html?conf2fullscreen=1&conf2scrollwhitearea=1&statusbar=0&origin=${this.TRIGGER_PAGE}`;
            if(JSON.stringify(this.receive_right_target)!="{}" && this.receive_right_target.target_web_url ) {
                url = this.receive_right_target.target_web_url;
            }
            if (this.ua.kkmh) return switch_page({
                action_type: 18,
                extra_params: {
                    target_id: 1,
                    target_title: "",
                    hybrid_url: url,
                    target_web_url: url
                },
                progress_bar: 1
            });
            location.href = url;
        },
        iconClickHandler(idx) {
            let iconListHeight = document.querySelector(".vip-icon-outter").clientHeight;
            let content = this.$refs.refContent[idx];
            let result = content.getBoundingClientRect().top - iconListHeight;
            window.scrollBy(0, result);
            this.$nextTick(() => {
                let list = this.$refs.refIcon;
                list.map((item, index) => {
                    item.classList.remove("active");
                    if (idx == index) item.classList.add("active");
                });
            });
        },
        loginOutCallback(){
            this.getUserLogin();
            this.getHomepageInfo();
        }
        // 绑定平台手机号 2021-11-10废弃 使用新弹窗解决
        // bindNativePhone() {
        //     if (this.ua.kkmh) {
        //         if (this.ua.appversion && this.ua.appversion >= 550000) {
        //             //支持绑定手机号协议
        //             let actionType = this.userBasePhone ? 65: 64;
        //             switch_page({ action_type: actionType });
        //         } else {
        //             this.showToast("当前版本过低，需升级快看漫画到最新版本后尝试操作。");
        //         }
        //     }
        // }
        
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss'; //NOSONAR
.header {
  position: relative;
  height: vws(631px);
  background: #f1f1f1;
  .go-back {
    position: absolute;
    top: vws(52px);
    left: vws(30px);
    width: vws(64px);
    height: vws(64px);
  }
    .user-info-box {
        position: absolute;
        top: vws(60px);
        left: vws(30px);
        background: rgba(28, 28, 28, .85);
        border-radius: vws(24px);
        padding: vws(4px) vws(24px) vws(4px) vws(4px);
        display: flex;
        align-items: center;
        .avatar-box {
            width: vws(36px);
            height: vws(36px);
            background: #8F3636;
            border: vws(2px) solid #FFFFFF;
            border-radius: 50%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        .user-name {
            font-size: vws(24px);
            line-height: 1;
            font-weight: 500;
            color: #FFFFFF;
            margin-left: vws(7px);
        }
    }
    .login-button {
        position: absolute;
        top: vws(60px);
        left: vws(30px);
        background: rgba(28, 28, 28, .85);
        color: #FFFFFF;
        width: vws(100px);
        text-align: center;
        padding: vws(10px) 0;
        font-size: vws(24px);
        font-weight: 500;
        line-height: 1;
        border-radius: vws(22px);
    }
  .rules-btn {
    z-index: 1;
    position: absolute;
    top: vws(50px);
    right: 0;
    width: vws(184px);
    height: vws(68px);
    background:rgba(0,0,0,.3);
    border-radius: vws(34px) 0 0 vws(34px);
    text-align: center;
    line-height: vws(68px);
    font-size: vws(30px);
    font-weight: 500;
    color: #fff;
    &.fix-right {
        top: vws(277px);
        right: 0;
        width: vws(48px);
        height: vws(155px);
        background: none;
    }
  }
  .share-btn {
    z-index: 1;
    position: absolute;
    top: vws(50px);
    right: vws(23px);
    width: vws(141px);
    height: vws(58px);
  }
  .kk-vip-info.black {
    background: #000;//#dedede;
  }
  .kk-vip-info {
    position: absolute;
    top: vws(277px);
    left: 50%;
    width: vws(620px);
    height: vws(203px);
    transform: translateX(-50%);
    border-radius: vws(20px);
    overflow: hidden;
    .info-title {
      position: absolute;
      left: vws(193px);
      top: vws(48px);
      width: vws(388px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: vws(26px);
      line-height: vws(32px);
      color: #FFDC71;;
      font-weight: bold;
    }
    .info-desc {
      position: absolute;
      left: vws(193px);
      top: vws(86px);
      width: vws(388px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #ccc;
      font-size: vws(22px);
      line-height: vws(24px);
      font-weight: 400;
    }
    .kk-icon {
      position: absolute;
      top: vws(26px);
      left: vws(52px);
      width: vws(100px);
      height: vws(100px);
      border-radius: vws(20px);
      background: transparent;
      .vip-type {
        position: absolute;
        right: vws(-10px);
        top: vws(-10px);
        &.auto-renew {
          right: vws(-35px);
        }
      }
    }
  }
}
.container {
  padding-bottom: vws(140px);
  background: transparent;
  transform: translateY(vws(-200px));
  &.no-trans {
    transform: none;
  }
}
  .vip-wrap {
    position: relative;
    margin: 0 auto;
    margin-bottom: vws(69px);
    padding: vws(62px) 0 vws(19px);
    width: vws(700px);
    min-height: vws(200px);
    box-shadow: 0px vws(4px) vws(10px) 0px rgba(0, 0, 0, 0.1);
    border-radius: vws(20px);
    background: #fff;
    .select-label {
      position: absolute;
      right: 0;
      top: 0;
      padding: 0 vws(24px);
      height: vws(40px);
      border-radius: vws(5px) vws(20px) 0 vws(5px);
      background: #FF4E4E;
      font-size: vws(24px);
      font-weight: 600;
      color: #fff;

    }
    .vip-type {
      position: absolute;
      right: vws(-10px);
      top: vws(-10px);
    }
    .vip-list.double {
      padding: 0 vws(50px);
      .vip-icon-wrap {
        margin-right: vws(17px);
      }
      .app-name {
        font-size: vws(28px);
      }
    }
    .vip-list.triple {
      padding: 0 vws(28px);
      .vip-item {
        max-width: vws(196px);
        flex-basis: vws(196px);
      }
    }
    .vip-list.four {
      .vip-item {
        max-width: vws(160px);
        flex-basis: vws(160px);
      }
    }
    .vip-item {
      margin-bottom: vws(30px);
      &:last-of-type {
        margin-right: 0!important;
      }
    }
    .vip-icon-wrap {
      position: relative;
      flex-shrink: 0;
      margin: 0 auto;
      width: vws(100px);
      height: vws(100px);
      background: transparent;
      border-radius: vws(20px);
    }
    .vip-info-wrap {
      white-space: nowrap;
      text-align: center;
    }
    .app-name {
      margin-top: vws(11px);
      margin-bottom: vws(8px);
      font-size: vws(24px);
      line-height: 1.15;
      font-weight: 600;
      color: #333333;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .desc {
      font-size: vws(22px);
      line-height: vws(24px);
      font-weight: 400;
      color: #999999;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .assign-tips {
      margin-top: vws(20px);
      padding: 0 vws(40px);
      font-size: vws(22px);
      font-weight: 400;
      color: #999999;
    }
    .countdown {
      flex-basis: vws(350px);
      text-align: right;
    }
    .times {
      flex-basis: vws(284px);
    }
  }
  .vip-type {
    padding: vws(6px) vws(10px);
    height: vws(16px);
    background: #4F9FFB;
    border-radius: vws(14px) vws(14px) vws(14px) vws(2px);
    font-size: vws(18px);
    font-weight: 600;
    color: #fff;
    &.year {
      background: #FF4E4E;
    }
    &.month {
      background: #4E6BE6;
    }
    &.season {
      background: #019E99;
    }
  }
  .rights-list {
    margin: 0 auto;
    width: vws(700px);
    text-align: center;
    .rights-title {
      width: vws(586px);
      height: vws(42px);
    }
    .vip-content-list {
      .vip-content-item {
        position: relative;
        margin-bottom: vws(30px);
        width: vws(700px);
        // height: vws(510px);
        background: #FFFFFF;
        box-shadow: 0px vws(4px) vws(10px) 0px rgba(0, 0, 0, 0.1);
        border-radius: vws(20px);
        .vip-icon {
          position: absolute;
          left: vws(41px);
          top: vws(30px);
          width: vws(100px);
          height: vws(100px);
          background: transparent;
          border-radius: vws(20px);
          overflow: hidden;
        }
        .icon-base {
          position: absolute;
          left: vws(25px);
          top: vws(120px);
          width: vws(132px);
          height: vws(71px);
        }
        .count {
          position: absolute;
          right: 0;
          top: 0;
          width: vws(94px);
          height: vws(40px);
          .number {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-40%, -50%);
            color: #fff;
          }
        }
        .vip-info-box {
          position: absolute;
          left: vws(180px);
          top: 0;
          padding-top: vws(45px);
          .vip-app-name {
            margin-bottom: vws(15px);
            font-size: vws(40px);
            line-height: vws(40px);
            font-weight: 600;
            color: #333;
          }
          .vip-desc {
            font-size: vws(26px);
            color: #999;
            font-weight: 400;
          }
          .vip-desc-item {
            margin-right: vws(13px);
          }
          .desc-icon {
            display: inline-block;
            width: vws(24px);
            height: vws(24px);
            background: url('./img/desc-icon.png') no-repeat 0 0 / 100% 100%;
          }
        }
        .bottom {
          padding: 0 vws(30px);
          padding-top: vws(194px);
          padding-bottom: vws(39px);
          .link-item {
            margin-right: vws(18px);
          }
          .link-img {
            img {
              display: block;
            }
            margin-bottom: vws(10px);
            width: vws(200px);
            background: #A0A0A0;
            border-radius: vws(20px);
            overflow: hidden;
          }
          .link-name {
            width: vws(200px);
            font-size: vws(24px);
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

    }
  }
.btn-item {
  margin: 0 auto;
  width: vws(590px);
  height: vws(86px);
  font-size: vws(34px);
  font-weight: 600;
  color: #442509;
  background: #FFE545;
  border-radius: vws(43px);
  &.disabled {
    background: #AAAAAA;
    color: #E6E5E5;
  }
  &.buy {
    &.small {
      margin-right: vws(55px);
      width: vws(352px);
    }
    position: relative;
    p {
      font-weight: bold;
    }
    .price {
      margin-left: vws(20px);
      color: #FF3737;
    }
    .small-rmb {
      transform: translateY(-1px);
      display: inline-block;
      font-size: vws(34px);
    }
    .sell-price {
      .num {
        line-height: vws(60px);
        font-size: vws(50px);
        font-weight: bold;
      }
    }
    .origin-price {
      margin-left: vws(8px);
      font-size: vws(24px);
      font-weight: 400;
      color: rgba(68,37,9, .4);
      text-decoration: line-through;
    }
    .label {
      position: absolute;
      right: vws(-17px);
      top: vws(-20px);
      padding: 0 vws(26px);
      height: vws(36px);
      background: #FF4E4E;
      border-radius: vws(18px) vws(18px) vws(18px) vws(4px);
      font-size: vws(22px);
      color: #fff;
      font-weight: 600;
      .save-price {
        color: #FEE437;
      }
    }
  }
  &.assign.small {
    margin-left: vws(55px);
    width: vws(212px);
    background: #442509;
    color: #fff;
  }
}
.vip-icon-outter {
  padding-top: vws(27px);
  padding-bottom: vws(33px);
}
.vip-icon {
  margin: 0 auto;
  width: vws(80px);
  height: vws(80px);
  background: transparent;
  border-radius: vws(16px);
}
.vip-name {
  margin-top: vws(9px);
  width: vws(137px);
  font-size: vws(22px);
  line-height: 1.15;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.6);
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}
.active .vip-name {
  font-size: vws(24px);
  font-weight: bold;
  color: #333;
}
.btn-wrap {
  z-index: 1;
  position: fixed;
  bottom: 0;
//   left: 0;
  left:50%;
  transform:translateX(-50%);
}
.btn-group {
  margin-top: vws(10px);
}
.btn-group.fixed {
  padding-top: vws(10px);
  padding-left: vws(25px);
  padding-right: vws(25px);
  width: vws(700px);
  height: vws(130px);
  background: url(./img/footer-bg-small.png) no-repeat 0 0 /100% 100%;
}
.vip-icon-outter.fixed {
  z-index: 11;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  text-align: center;
  background: #fff;
}
.vip-icon-list {
  width: vws(750px - 35px -30px);
}
.vip-list-wrap {
  width: vws(750px - 35px -30px);
  overflow-x: scroll;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    z-index: -1111;
    display: none;
    width: 0;
    height: 0;
  }

}
.vip-icon-wrap {
  overflow: hidden;
}
.block {
  z-index: 11;
  position: fixed;
  top: 0;
  right: 0;
  width: vws(30px);
  height: 100%;
  background: #fff;
}
.btn-base {
  display: none;
  width: 100%;
  height: vws(60px);
  background: #fff;
}
.kk-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
/* iphonex xs */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .vip-icon-outter.fixed {
    padding-top: vws(88px);
  }
  .btn-base {
    display: block;
  }
  .container {
    padding-bottom: vws(200px);
  }
}

/* iphonex max  xs max*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .vip-icon-outter.fixed {
    padding-top: vws(88px);
  }
  .btn-base {
    display: block;
  }
  .container {
    padding-bottom: vws(200px);
  }
}

/* iphone xr*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:2) {
  .vip-icon-outter.fixed {
    padding-top: vws(88px);
  }
  .btn-base {
    display: block;
  }
  .container {
    padding-bottom: vws(200px);
  }

}
.error-go-back {
  padding-top: vws(27px);
  padding-left: vws(25px);
  width: vws(67px);
  height: vws(67px);
}
.error {
  display: block;
  margin: 0 auto;
  margin-top: vws(296px);
  width: vws(236px);
  height: vws(288px);
}
.error-text {
  margin-top: vws(19px);
  font-size: vws(25px);
  color: #8B8B8B;
  line-height: vws(35px);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/app.vue